import { restrictedAccess } from '../middleware'

export default {
  path: '/',
  name: 'dashboard',
  component: () => import('@/views/admin/Dashboard'),
  beforeEnter: restrictedAccess(5),
}